import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  CompensationsFinanceCategoryFragment,
  PayrollConceptFragment,
  ReimbursablePayrollConceptFragment,
} from 'generated/resources/graphql'
import { isString } from 'lodash'

import { PayrollConceptSelect } from 'modules/compensations/components/PayrollConceptSelectField'
import { useCategorizedPayrollConcepts } from 'modules/compensations/components/PayrollConceptSelectField/CategorizedPayrollConceptUtil'

interface Props {
  expenseCategory: CompensationsFinanceCategoryFragment
  payrollConcepts: PayrollConceptFragment[]
  reimbursement?: ReimbursablePayrollConceptFragment
  onRowChanged: (expenseCategoryId: string, payrollConceptId: string) => void
}

const ExpensesReimbursementRow = ({
  expenseCategory,
  payrollConcepts,
  reimbursement,
  onRowChanged,
}: Props) => {
  const payrollConceptsOptions = useCategorizedPayrollConcepts(payrollConcepts ?? [])

  if (!expenseCategory) return null

  const selectedPayrollConceptId = reimbursement?.payrollConceptId
    ? [reimbursement.payrollConceptId]
    : []

  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{expenseCategory?.label}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <PayrollConceptSelect
          payrollConcepts={payrollConceptsOptions}
          value={selectedPayrollConceptId}
          onChange={(payrollConceptId) => {
            isString(payrollConceptId) && onRowChanged(expenseCategory.id, String(payrollConceptId))
          }}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default ExpensesReimbursementRow
